module.exports = __webpack_public_path__ + "img/智慧高速.b9d7fed2.png";